import { AbstractControl, ValidationErrors } from '@angular/forms';

export function urlValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = (control.value || '').trim();
  if (!value) {
    return null; // campo opzionale
  }
  const urlRegex =
    /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\/[^\s]*)?$/;
  return urlRegex.test(value) ? null : { url: true };
}
